import type { GanttTask } from './types';

export function canMoveTask(task: GanttTask, chartReadOnly?: boolean): boolean {
  if (chartReadOnly) return false;
  if (task.draggable === false) return false;
  if (task.readOnly && task.draggable !== true) return false;
  return true;
}
